export const TOGGLE_ELEMENT_VISIBILITY = "TOGGLE_ELEMENT_VISIBILITY";
export const SET_CURRENT_EXPOSURES_KEYS = "SET_CURRENT_EXPOSURES_KEYS";
